import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import {AccessUserInfo } from 'src/app/models';
@Component({
  selector: 'bart-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    "(window:resize)":"onWindowResize($event)"
  }
})
export class DashboardComponent implements OnInit {
  userId:number;
  bartRoleCode:string;
  userName:string
  bartRoleId:number;
  userAssignedFacilityNumbers:string;
  //#region  Dynamic Height Variable
  public mainBoxHeight:number 
  //#endregion
  constructor() { 

  }
  ngOnInit() {
    let userInfo = AccessUserInfo.getUserInfo();
    if(userInfo!=null)
    {
      this.userId=userInfo.userId
      this.bartRoleCode=userInfo.bartRoleCode
      this.userName=userInfo.userName
      this.bartRoleId=userInfo.bartRoleId
      this.userAssignedFacilityNumbers=userInfo.assignedFacilityNumbers
    }
    this.calCulateHieght(window.innerHeight);
  }
  onWindowResize(event) {
    this.calCulateHieght(event.target.innerHeight);
  }
  public calCulateHieght(winHeight:number)
  {
    var topBarheight = document.getElementById("topBar").offsetHeight+document.getElementById("topBar").offsetTop;;
    var bottomPanelBarHeight =20; //document.getElementById("divBottomPanelBar").offsetHeight;
    this.mainBoxHeight=winHeight-(topBarheight+bottomPanelBarHeight+10);
  }
}
